import { useEffect } from "react";
import { SITE } from "@/data/content";

const upsertMeta = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [attr, value] = selector.includes("property=")
      ? ["property", selector.match(/property="([^"]+)"/)[1]]
      : ["name", selector.match(/name="([^"]+)"/)[1]];
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const upsertJsonLd = (data) => {
  let el = document.head.querySelector('script[data-seo="page"]');
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.setAttribute("data-seo", "page");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const SEO = ({ title, description, path = "/", breadcrumbs = [] }) => {
  useEffect(() => {
    const fullUrl = `${SITE.url}${path === "/" ? "/" : path}`;
    document.title = title;
    upsertMeta('meta[name="description"]', { content: description });
    upsertMeta('meta[property="og:title"]', { content: title });
    upsertMeta('meta[property="og:description"]', { content: description });
    upsertMeta('meta[property="og:url"]', { content: fullUrl });
    upsertMeta('meta[name="twitter:title"]', { content: title });
    upsertMeta('meta[name="twitter:description"]', { content: description });
    upsertLink("canonical", fullUrl);

    upsertJsonLd({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": `${fullUrl}#webpage`,
          url: fullUrl,
          name: title,
          description,
          isPartOf: { "@id": `${SITE.url}/#website` },
          about: { "@id": `${SITE.url}/#organization` },
        },
        ...(breadcrumbs.length
          ? [
              {
                "@type": "BreadcrumbList",
                itemListElement: breadcrumbs.map((b, i) => ({
                  "@type": "ListItem",
                  position: i + 1,
                  name: b.name,
                  item: `${SITE.url}${b.path}`,
                })),
              },
            ]
          : []),
      ],
    });
  }, [title, description, path, breadcrumbs]);

  return null;
};

export default SEO;
